import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostAbschnittCommandServiceModule } from '..';
import { PostAbschnittCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostAbschnittCommandServiceModule
  ],
  declarations: [PostAbschnittCommandComponent],
  exports: [PostAbschnittCommandComponent],

})
export class PostAbschnittCommandComponentModule { }
